// ---------------------------------------------
// auto-generated from materia/explica-overlays.jsx
// edit the source there and run `npm run sync`
// ---------------------------------------------
import React from "react";
import { MChip, MEye, MChart } from "./prims.jsx";
import { Icon } from "../screens-cristal/primitives.jsx";
import { ExplicaShell } from "./explica-player.jsx";

// Helper: dimmed player background (placeholder behind overlay) ───
export const PlayerBackdrop = () => (
  <div style={{ flex: 1, padding: "20px 28px 0", display: "flex", flexDirection: "column", filter: "blur(2px) brightness(0.7)", opacity: 0.65 }}>
    <span className="mono" style={{ fontSize: 11, color: "var(--m-text-3)", letterSpacing: "0.14em", textTransform: "uppercase" }}>Acto · A3 · Aplicación en chart</span>
    <div className="m-objective" style={{ marginTop: 10 }}>
      <div>
        <div className="eye">Pregunta del usuario</div>
        <div className="text" style={{ marginTop: 2, fontSize: 14 }}>¿Qué confirmaría la ruptura?</div>
      </div>
    </div>
    <div style={{ marginTop: 14, flex: 1 }}>
      <MChart width={700} height={380} caption="XYZ · 1D"
        overlays={[
          { type: "zone", topPct: 24, bottomPct: 32, color: "copper", label: "R" },
          { type: "marker", xPct: 70, yPct: 18, label: "cierre fuera", kind: "decision" },
        ]}/>
    </div>
  </div>
);

// ─────────────────────────────────────────────────────────
// 1. Tutor / Panel · refusal + hint ladder (deep view)
// ─────────────────────────────────────────────────────────
export const ScreenMOverlayTutor = () => (
  <ExplicaShell
    label="Explica · Tutor / Panel"
    act={3}
    sourceProps={{ note: "TutorPanel · refusal pattern + hint ladder · MCP contextual" }}
    right={
      <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden", background: "rgba(0,0,0,0.18)" }}>
        {/* tabs */}
        <div style={{ display: "flex", height: 38, borderBottom: "1px solid var(--m-line)", background: "var(--m-metal)" }}>
          {[
            { k: "tutor", l: "Tutor", on: true },
            { k: "source", l: "Fuente" },
            { k: "gloss", l: "Glosario" },
          ].map((t, i) => (
            <div key={i} style={{
              flex: 1, display: "flex", alignItems: "center", justifyContent: "center", gap: 6,
              fontFamily: "var(--m-t-mono)", fontSize: 10.5, letterSpacing: "0.1em", textTransform: "uppercase",
              color: t.on ? "var(--m-text)" : "var(--m-text-3)",
              borderBottom: t.on ? "2px solid var(--m-primary)" : "2px solid transparent",
            }}>{t.l}</div>
          ))}
        </div>

        <div style={{ flex: 1, padding: 16, overflow: "auto", display: "flex", flexDirection: "column", gap: 14 }}>
          {/* safety badge */}
          <div className="m-chip" style={{
            background: "rgba(155,184,106,0.10)", borderColor: "rgba(155,184,106,0.32)", color: "var(--m-positive)",
            alignSelf: "flex-start",
          }}>
            <Icon name="shield" size={10}/> Tutor educativo · sin recomendaciones
          </div>

          {/* refusal pattern */}
          <div className="m-misconception" style={{ padding: 14 }}>
            <div className="lbl">tutor · refusal pattern</div>
            <div style={{ fontSize: 13, marginTop: 8, lineHeight: 1.45, textWrap: "pretty", color: "var(--m-text-2)" }}>
              No puedo recomendar comprar, vender o mantener. Lo que <em>sí</em> puedo hacer:
            </div>
            <div style={{ marginTop: 10, display: "flex", flexDirection: "column", gap: 6 }}>
              {[
                { i: "ind",     t: "explicarte por qué este patrón importa" },
                { i: "link",    t: "mostrarte fuentes y timestamp" },
                { i: "help",    t: "preguntarte qué evidencia falta" },
                { i: "spark",   t: "generarte una práctica similar" },
              ].map((a, i) => (
                <button key={i} className="m-btn ghost sm" style={{ justifyContent: "flex-start", padding: "0 10px" }}>
                  <Icon name={a.i} size={11}/> {a.t}
                </button>
              ))}
            </div>
          </div>

          {/* conversation */}
          <div>
            <MEye>Conversación · A3 · Soportes y resistencias</MEye>
            <div style={{ marginTop: 10, display: "flex", flexDirection: "column", gap: 10 }}>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <div style={{ maxWidth: 280, padding: "8px 12px", borderRadius: "8px 8px 2px 8px", background: "var(--m-metal-2)", border: "1px solid var(--m-line)", fontSize: 12 }}>
                  ¿Debería comprar XYZ si cierra fuera de zona?
                </div>
              </div>
              <div style={{ padding: 10, border: "1px solid rgba(216,168,104,0.28)", background: "rgba(216,168,104,0.06)", borderRadius: "8px 8px 8px 2px" }}>
                <div className="mono" style={{ fontSize: 9.5, color: "var(--m-accent)", letterSpacing: "0.1em" }}>TUTOR · profesor_analista</div>
                <div style={{ fontSize: 12.5, marginTop: 6, lineHeight: 1.45 }}>
                  Esa pregunta sale del aula. Vuelvo al patrón: <em style={{ color: "var(--m-accent)" }}>¿qué evidencia cambiaría tu opinión</em> sobre la ruptura?
                </div>
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <div style={{ maxWidth: 280, padding: "8px 12px", borderRadius: "8px 8px 2px 8px", background: "var(--m-metal-2)", border: "1px solid var(--m-line)", fontSize: 12 }}>
                  Si el cierre vuelve dentro de la zona en 4h.
                </div>
              </div>
              <div style={{ padding: 10, border: "1px solid rgba(216,168,104,0.28)", background: "rgba(216,168,104,0.06)", borderRadius: "8px 8px 8px 2px" }}>
                <div className="mono" style={{ fontSize: 9.5, color: "var(--m-accent)", letterSpacing: "0.1em" }}>TUTOR</div>
                <div style={{ fontSize: 12.5, marginTop: 6, lineHeight: 1.45 }}>
                  Buen criterio. Esa es una <strong>condición de invalidación</strong>. ¿Cuál sería la confirmación opuesta?
                </div>
              </div>
            </div>
          </div>

          {/* input */}
          <div style={{ marginTop: "auto" }}>
            <textarea placeholder="Tu respuesta…" rows={2} style={{
              width: "100%", padding: 10, fontFamily: "var(--m-t-sans)", fontSize: 12,
              background: "var(--m-bg-deep)", border: "1px solid var(--m-line)", borderRadius: 4,
              color: "var(--m-text)", resize: "none", boxSizing: "border-box",
            }}/>
            <div style={{ display: "flex", justifyContent: "space-between", marginTop: 8, gap: 6 }}>
              <div style={{ display: "flex", gap: 4 }}>
                <button className="m-iconbtn" style={{ width: 28, height: 28 }}><Icon name="mic" size={11}/></button>
                <button className="m-iconbtn" style={{ width: 28, height: 28 }}><Icon name="lightbulb" size={11}/></button>
              </div>
              <button className="m-btn accent sm"><Icon name="send" size={11}/> Enviar</button>
            </div>
          </div>
        </div>
      </div>
    }
    center={
      <div style={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
        <PlayerBackdrop/>
        <div style={{ padding: 14, borderTop: "1px solid var(--m-line)", display: "flex", justifyContent: "space-between", alignItems: "center", background: "var(--m-metal)" }}>
          <MChip variant="warn">tutor · activo · MCP contextual</MChip>
          <span className="mono" style={{ fontSize: 11, color: "var(--m-text-3)" }}>player en pausa · resume_exact_scene_timecode</span>
        </div>
      </div>
    }
  />
);

// ─────────────────────────────────────────────────────────
// 2. Source / Panel · full
// ─────────────────────────────────────────────────────────
export const ScreenMOverlaySource = () => (
  <ExplicaShell
    label="Explica · Source / Panel"
    act={3}
    sourceProps={{ note: "SourcePanel · publisher · license · claim_strength · evidence bundle EVB-217" }}
    right={
      <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden", background: "rgba(0,0,0,0.18)" }}>
        <div style={{ display: "flex", height: 38, borderBottom: "1px solid var(--m-line)", background: "var(--m-metal)" }}>
          {[
            { l: "Tutor" },
            { l: "Fuente", on: true },
            { l: "Glosario" },
          ].map((t, i) => (
            <div key={i} style={{
              flex: 1, display: "flex", alignItems: "center", justifyContent: "center",
              fontFamily: "var(--m-t-mono)", fontSize: 10.5, letterSpacing: "0.1em", textTransform: "uppercase",
              color: t.on ? "var(--m-text)" : "var(--m-text-3)",
              borderBottom: t.on ? "2px solid var(--m-primary)" : "2px solid transparent",
            }}>{t.l}</div>
          ))}
        </div>

        <div style={{ flex: 1, padding: 16, overflow: "auto", display: "flex", flexDirection: "column", gap: 14 }}>
          {/* header */}
          <div className="m-panel" style={{ padding: 14 }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <MEye>Fuente primaria</MEye>
              <MChip variant="live">live · delay 15m</MChip>
            </div>
            <table style={{ width: "100%", marginTop: 12, fontFamily: "var(--m-t-mono)", fontSize: 11, color: "var(--m-text-2)" }}>
              <tbody>
                {[
                  ["publisher", "vendor_primary"],
                  ["dataset", "DB.market_ohlcv"],
                  ["símbolo", "XYZ · 1D"],
                  ["ventana", "últimas 200 sesiones"],
                  ["retrieved", "2026-05-17 · 14:32 UTC"],
                  ["license", "tier_2 · uso educativo"],
                ].map(([k, v], i) => (
                  <tr key={i} style={{ borderBottom: "1px solid var(--m-line)" }}>
                    <td style={{ color: "var(--m-text-3)", padding: "5px 0", width: 90 }}>{k}</td>
                    <td style={{ padding: "5px 0" }}>{v}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="m-panel" style={{ padding: 14 }}>
            <MEye>Claim strength</MEye>
            <div style={{ marginTop: 12, display: "flex", flexDirection: "column", gap: 8 }}>
              {[
                { l: "observación", v: "HIGH", c: "var(--m-positive)", pct: 80 },
                { l: "interpretación", v: "MEDIUM", c: "var(--m-warn)", pct: 50 },
                { l: "causalidad", v: "NOT CLAIMED", c: "var(--m-text-3)", pct: 0 },
              ].map((s, i) => (
                <div key={i}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span style={{ fontSize: 11.5, color: "var(--m-text-2)" }}>{s.l}</span>
                    <span className="mono" style={{ fontSize: 10, color: s.c }}>{s.v}</span>
                  </div>
                  <div style={{ height: 3, background: "rgba(216,196,160,0.08)", borderRadius: 2, marginTop: 4, overflow: "hidden" }}>
                    <div style={{ width: `${s.pct}%`, height: "100%", background: s.c, opacity: 0.6 }}/>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="m-panel" style={{ padding: 14 }}>
            <MEye>Documentos asociados</MEye>
            <div style={{ marginTop: 10, display: "flex", flexDirection: "column", gap: 6 }}>
              {[
                { i: "book", t: "Metodología del indicador", d: "PDF · 14 págs" },
                { i: "list", t: "Registro de revisión (changelog)", d: "12 entradas" },
                { i: "stack", t: "Evidence bundle EVB-217", d: "8 fuentes" },
              ].map((d, i) => (
                <button key={i} className="m-btn ghost sm" style={{ justifyContent: "flex-start", padding: "8px 10px", height: "auto" }}>
                  <Icon name={d.i} size={12}/>
                  <span style={{ flex: 1, textAlign: "left" }}>
                    <span style={{ display: "block", fontSize: 11.5 }}>{d.t}</span>
                    <span className="mono" style={{ fontSize: 9.5, color: "var(--m-text-3)", marginTop: 2 }}>{d.d}</span>
                  </span>
                  <Icon name="next" size={11}/>
                </button>
              ))}
            </div>
          </div>

          <div className="m-chip" style={{
            alignSelf: "flex-start", background: "rgba(155,184,106,0.10)", borderColor: "rgba(155,184,106,0.32)", color: "var(--m-positive)",
          }}>
            <Icon name="shield" size={10}/> Educativo · no es recomendación
          </div>
        </div>
      </div>
    }
    center={
      <div style={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
        <PlayerBackdrop/>
        <div style={{ padding: 14, borderTop: "1px solid var(--m-line)", display: "flex", justifyContent: "space-between", alignItems: "center", background: "var(--m-metal)" }}>
          <MChip variant="copper">fuente · panel abierto</MChip>
          <span className="mono" style={{ fontSize: 11, color: "var(--m-text-3)" }}>fuentes a un tap · siempre on-demand</span>
        </div>
      </div>
    }
  />
);

// ─────────────────────────────────────────────────────────
// 3. Glossary / Tooltip · over an Explica scene
// ─────────────────────────────────────────────────────────
export const ScreenMOverlayGlossary = () => (
  <ExplicaShell
    label="Explica · Glossary tooltip + Branch menu"
    act={3}
    sourceProps={{ note: "GlossaryTooltip + BranchMenu · tap en término técnico → tooltip con micro-visual" }}
    center={
      <div style={{ flex: 1, position: "relative", display: "flex", flexDirection: "column", padding: "20px 28px 0", minHeight: 0 }}>
        <span className="mono" style={{ fontSize: 11, color: "var(--m-text-3)", letterSpacing: "0.14em", textTransform: "uppercase" }}>Acto · A3 · Aplicación en chart</span>

        {/* a sentence with underlined term */}
        <h2 style={{ fontSize: 22, fontWeight: 600, marginTop: 12, lineHeight: 1.35, letterSpacing: "-0.01em", maxWidth: 760, textWrap: "pretty" }}>
          Cuando el precio cruza una <span style={{
            borderBottom: "1.5px dashed var(--m-accent)", color: "var(--m-accent)", padding: "0 2px", cursor: "help", position: "relative",
          }}>resistencia
            {/* Tooltip popover */}
            <span style={{
              position: "absolute", top: "100%", left: "50%", transform: "translate(-50%, 12px)",
              width: 320, padding: 14, zIndex: 8,
              background: "var(--m-bg)", border: "1px solid var(--m-line-strong)", borderRadius: 8,
              boxShadow: "0 20px 50px rgba(0,0,0,0.55), inset 0 1px 0 rgba(216,196,160,0.08)",
              fontFamily: "var(--m-t-sans)", color: "var(--m-text)", fontWeight: 400, cursor: "default",
            }}>
              {/* arrow */}
              <span style={{
                position: "absolute", top: -7, left: "50%", transform: "translateX(-50%) rotate(45deg)",
                width: 12, height: 12, background: "var(--m-bg)",
                borderTop: "1px solid var(--m-line-strong)", borderLeft: "1px solid var(--m-line-strong)",
              }}/>
              <div className="mono" style={{ fontSize: 9.5, color: "var(--m-accent)", letterSpacing: "0.12em", textTransform: "uppercase" }}>resistencia</div>
              <div className="m-serif" style={{ fontSize: 14, lineHeight: 1.4, marginTop: 8, fontStyle: "normal", letterSpacing: "-0.005em" }}>
                Zona donde antes apareció oferta o frenó el avance del precio. <em style={{ color: "var(--m-accent)" }}>No es una línea exacta.</em>
              </div>
              <div style={{ marginTop: 10, borderRadius: 4, overflow: "hidden" }}>
                <MChart width={290} height={70} caption="" ohlcLabel={false} showVolume={false}
                  yLabels={[]} xLabels={[]} withGrid={false}
                  overlays={[
                    { type: "zone", topPct: 30, bottomPct: 50, color: "default", label: "R" },
                  ]}/>
              </div>
              <div style={{ marginTop: 10, display: "flex", justifyContent: "space-between" }}>
                <button className="m-btn ghost sm" style={{ height: 24 }}>Ver más</button>
                <button className="m-btn ghost sm" style={{ height: 24 }}><Icon name="save" size={10}/> Flashcard</button>
              </div>
            </span>
          </span> sin <span style={{ borderBottom: "1px dotted var(--m-text-3)", color: "var(--m-text-2)" }}>cerrar fuera de zona</span>, lo más probable es una <span style={{ borderBottom: "1px dotted var(--m-text-3)", color: "var(--m-text-2)" }}>falsa ruptura</span>.
        </h2>

        {/* chart smaller */}
        <div style={{ marginTop: 28 }}>
          <MChart width={680} height={260} caption="XYZ · 1D"
            overlays={[
              { type: "zone", topPct: 26, bottomPct: 34, color: "copper", label: "R" },
              { type: "marker", xPct: 70, yPct: 22, label: "cruce", kind: "decision" },
            ]}/>
        </div>

        {/* Branch menu floating */}
        <div className="m-panel" style={{
          position: "absolute", right: 40, bottom: 80, width: 280, padding: 14,
          boxShadow: "0 20px 50px rgba(0,0,0,0.55)",
        }}>
          <MEye>Continúa explorando</MEye>
          <div style={{ marginTop: 10, display: "flex", flexDirection: "column", gap: 4 }}>
            {[
              { i: "book", t: "Glosario inline (resistencia)" },
              { i: "draw", t: "Lab guiado · dibujar zona" },
              { i: "link", t: "Source panel · evidence" },
              { i: "help", t: "Tutor MCP (escena actual)" },
              { i: "movie",t: "Explica · falsa ruptura" },
            ].map((b, i) => (
              <button key={i} className="m-btn ghost sm" style={{ justifyContent: "flex-start", padding: "8px 10px", height: "auto" }}>
                <Icon name={b.i} size={11}/>
                <span style={{ flex: 1, textAlign: "left" }}>{b.t}</span>
                <Icon name="next" size={10} style={{ color: "var(--m-text-3)" }}/>
              </button>
            ))}
          </div>
        </div>
      </div>
    }
  />
);

// ─────────────────────────────────────────────────────────
// 4. State / LowBandwidth
// ─────────────────────────────────────────────────────────
export const ScreenMStateLowBw = () => (
  <ExplicaShell
    label="Explica · State / LowBandwidth"
    act={3}
    sourceProps={{ note: "modo low-bandwidth · paridad de información clave · OHLCV en tabla + audio comprimido" }}
    right={
      <div style={{ flex: 1, padding: 18, overflow: "auto" }}>
        <MEye>Modo low-bandwidth</MEye>
        <div className="m-misconception" style={{ marginTop: 12, padding: 14 }}>
          <div className="lbl">degradación inteligente</div>
          <div style={{ fontSize: 12.5, marginTop: 8, lineHeight: 1.4 }}>
            Detectamos red lenta. Cambiamos a texto + chart estático + audio comprimido. <strong>El aprendizaje no se degrada</strong>.
          </div>
        </div>

        <div className="m-divider" style={{ margin: "16px 0" }}/>

        <MEye>Volverá lo que falta cuando</MEye>
        <div style={{ marginTop: 10, display: "flex", flexDirection: "column", gap: 6, fontSize: 12, color: "var(--m-text-2)" }}>
          <div>· Conexión &gt; 1 Mbps · video del player</div>
          <div>· Conexión &gt; 2 Mbps · gráficos animados</div>
          <div>· Conexión &gt; 3 Mbps · caso vivo live</div>
        </div>

        <div className="m-divider" style={{ margin: "16px 0" }}/>

        <button className="m-btn ghost sm" style={{ width: "100%", justifyContent: "flex-start" }}>
          <Icon name="wifi-off" size={11}/> Forzar low-bandwidth siempre
        </button>
        <button className="m-btn ghost sm" style={{ width: "100%", justifyContent: "flex-start", marginTop: 6 }}>
          <Icon name="book" size={11}/> Descargar reading mode
        </button>
      </div>
    }
    center={
      <div style={{ flex: 1, padding: "20px 28px 0", display: "flex", flexDirection: "column", overflow: "auto" }}>
        {/* Banner */}
        <div style={{
          padding: 14, borderRadius: 4,
          background: "rgba(216,168,104,0.08)", border: "1px solid rgba(216,168,104,0.3)",
          display: "flex", alignItems: "center", gap: 12,
        }}>
          <Icon name="wifi-off" size={18} style={{ color: "var(--m-warn)" }}/>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 13, fontWeight: 600 }}>Modo low-bandwidth activo</div>
            <div style={{ fontSize: 11.5, color: "var(--m-text-2)", marginTop: 2 }}>Conexión lenta detectada · texto + chart estático + audio comprimido · paridad de información clave</div>
          </div>
          <button className="m-btn ghost sm"><Icon name="x" size={11}/></button>
        </div>

        <span className="mono" style={{ fontSize: 11, color: "var(--m-text-3)", letterSpacing: "0.14em", textTransform: "uppercase", marginTop: 20 }}>Acto · A3 · sin movie · texto + chart estático</span>

        <h2 className="m-serif" style={{ fontSize: 30, fontWeight: 600, lineHeight: 1.15, letterSpacing: "-0.025em", marginTop: 8, fontStyle: "normal", maxWidth: 760, textWrap: "balance" }}>
          ¿Qué confirmaría la <em style={{ color: "var(--m-accent)" }}>ruptura</em>?
        </h2>

        <p style={{ fontSize: 15, marginTop: 14, color: "var(--m-text)", lineHeight: 1.55, maxWidth: 760, textWrap: "pretty" }}>
          La confirmación es un <strong>conjunto de evidencias</strong>: cierre fuera de zona en el timeframe relevante, volumen relativo significativamente por encima de su media móvil y un contexto general que no contradiga la lectura.
        </p>

        <div style={{ marginTop: 18, display: "grid", gridTemplateColumns: "1.4fr 1fr", gap: 18 }}>
          <div>
            <MChart width={460} height={220} caption="XYZ · 1D · estático (no anim)" showVolume={false}
              overlays={[
                { type: "zone", topPct: 26, bottomPct: 34, color: "copper", label: "R" },
                { type: "marker", xPct: 70, yPct: 22, label: "cierre", kind: "decision" },
              ]}/>
            <div className="mono" style={{ fontSize: 10, color: "var(--m-text-3)", marginTop: 6, textAlign: "center" }}>
              Fig. 1 · imagen estática · paridad con player
            </div>
          </div>
          <div className="m-panel" style={{ padding: 14 }}>
            <MEye>Datos OHLCV · tabla</MEye>
            <table style={{ width: "100%", marginTop: 10, fontFamily: "var(--m-t-mono)", fontSize: 10.5, color: "var(--m-text-2)" }}>
              <thead>
                <tr style={{ color: "var(--m-text-3)", textAlign: "left" }}>
                  <th style={{ fontSize: 9.5, padding: "4px 0", fontWeight: 400 }}>fecha</th>
                  <th style={{ fontSize: 9.5, padding: "4px 0", fontWeight: 400 }}>O</th>
                  <th style={{ fontSize: 9.5, padding: "4px 0", fontWeight: 400 }}>H</th>
                  <th style={{ fontSize: 9.5, padding: "4px 0", fontWeight: 400 }}>L</th>
                  <th style={{ fontSize: 9.5, padding: "4px 0", fontWeight: 400 }}>C</th>
                  <th style={{ fontSize: 9.5, padding: "4px 0", fontWeight: 400 }}>vol·R</th>
                </tr>
              </thead>
              <tbody>
                {[
                  ["05-12", "101.2", "102.0", "100.6", "101.4", "0.9"],
                  ["05-13", "101.5", "102.4", "101.0", "102.1", "1.1"],
                  ["05-14", "102.0", "102.4", "101.5", "101.7", "0.8"],
                  ["05-15", "101.7", "102.4", "101.6", "102.4", "1.0"],
                  ["05-16", "102.4", "103.6", "102.1", "103.2", "1.6", true],
                  ["05-17", "103.2", "103.8", "102.7", "103.6", "1.4", true],
                ].map((r, i) => (
                  <tr key={i} style={{ borderTop: "1px solid var(--m-line)", background: r[6] ? "rgba(216,168,104,0.08)" : "transparent" }}>
                    {r.slice(0, 6).map((cell, j) => (
                      <td key={j} style={{ padding: "5px 0", color: j === 5 && r[6] ? "var(--m-accent)" : undefined }}>{cell}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    }
  />
);

// ─────────────────────────────────────────────────────────
// 5. State / NoLiveCase
// ─────────────────────────────────────────────────────────
export const ScreenMStateNoLive = () => (
  <ExplicaShell
    label="Explica · State / NoLiveCase"
    act={4}
    sourceProps={{ source: "historical · ABC 1D · 2023-10", time: "verificado 2024-01", note: "fallback histórico verificado · sin contaminación pedagógica" }}
    center={
      <div style={{ flex: 1, padding: "20px 28px 0", display: "flex", flexDirection: "column", overflow: "auto" }}>
        {/* banner */}
        <div style={{
          padding: 14, borderRadius: 4,
          background: "rgba(140, 125, 98, 0.10)", border: "1px solid rgba(140, 125, 98, 0.3)",
          display: "flex", alignItems: "center", gap: 12,
        }}>
          <Icon name="globe" size={18} style={{ color: "var(--m-text-3)" }}/>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 13, fontWeight: 600 }}>Sin caso vivo apto hoy</div>
            <div style={{ fontSize: 11.5, color: "var(--m-text-2)", marginTop: 2 }}>
              Aprenderás con un caso <strong>histórico verificado</strong> equivalente. El concepto y los gates son los mismos.
            </div>
          </div>
          <MChip variant="neutral">historical fallback</MChip>
        </div>

        <span className="mono" style={{ fontSize: 11, color: "var(--m-text-3)", letterSpacing: "0.14em", textTransform: "uppercase", marginTop: 22 }}>Acto · A4 · caso vivo → histórico</span>
        <h2 style={{ fontSize: 26, fontWeight: 600, lineHeight: 1.2, marginTop: 8, letterSpacing: "-0.015em" }}>
          Una ruptura ambigua en ABC, <em className="m-serif" style={{ color: "var(--m-accent)", fontStyle: "normal" }}>octubre 2023</em>.
        </h2>
        <div style={{ fontSize: 13, color: "var(--m-text-2)", marginTop: 8 }}>Verificado por equipo editorial · contexto declarado · no contamina progreso si el live cae</div>

        <div style={{ marginTop: 22, display: "grid", gridTemplateColumns: "1.6fr 1fr", gap: 18, flex: 1, minHeight: 0 }}>
          <MChart width={560} height={340} caption="ABC · 1D · oct 2023"
            overlays={[
              { type: "zone", topPct: 24, bottomPct: 32, color: "copper", label: "R" },
              { type: "marker", xPct: 55, yPct: 20, label: "cierre", kind: "decision" },
              { type: "marker", xPct: 75, yPct: 32, label: "vuelve dentro · falsa", kind: "x" },
            ]}/>

          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            <div className="m-panel" style={{ padding: 14 }}>
              <MEye>Por qué este caso</MEye>
              <ul style={{ listStyle: "none", padding: 0, marginTop: 10, display: "flex", flexDirection: "column", gap: 8 }}>
                {[
                  "Mismo concepto: ruptura vs falsa ruptura",
                  "Patrón de volumen similar al caso vivo previsto",
                  "Resultado conocido permite verificar enseñanza",
                  "Verificado por editorial el 2024-01-12",
                ].map((t, i) => (
                  <li key={i} style={{ display: "flex", gap: 10, fontSize: 12.5, color: "var(--m-text-2)", lineHeight: 1.4 }}>
                    <Icon name="check" size={12} style={{ color: "var(--m-positive)", marginTop: 3, flexShrink: 0 }}/>
                    <span>{t}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="m-misconception" style={{ padding: 14 }}>
              <div className="lbl">no contamina</div>
              <div style={{ fontSize: 11.5, color: "var(--m-text-2)", marginTop: 6, lineHeight: 1.4 }}>
                Tu progreso del módulo no depende de que haya caso vivo apto cualquier día.
              </div>
            </div>
            <button className="m-btn primary" style={{ alignSelf: "flex-start" }}>
              <Icon name="play" size={13}/> Empezar con histórico
            </button>
          </div>
        </div>
      </div>
    }
  />
);
